export default __webpack_public_path__ + "static/Nerd-c563c1d018e9a7380fe02fec89626570.png";